// src/pages/LinkTypeList.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function LinkTypeList() {
    const [linkTypes, setLinkTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    const fetchLinkTypes = async () => {
        setLoading(true);
        try {
            const res = await api.get("/type-links");
            setLinkTypes(res.data);
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la récupération des Type Links.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLinkTypes();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("Voulez-vous vraiment supprimer ce Type Link ?")) return;

        try {
            await api.delete(`/type-links/${id}`);
            alert("Type Link supprimé !");
            fetchLinkTypes(); // Recharge la liste
        } catch (err) {
            console.error(err);
            if (err.response && err.response.status === 409) {
                alert("Impossible de supprimer ce Type Link : il est utilisé par un produit.");
            } else {
                alert("Erreur lors de la suppression du Type Link.");
            }
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Liste des Type Links</h1>

            <button
                onClick={() => navigate("/add-linktype")}
                className="bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded px-4 py-2 mb-4"
            >
                Ajouter un Type Link
            </button>

            {loading ? (
                <Loading message="Chargement des Type Links..." />
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border text-sm text-center">
                        <thead className="bg-gray-100 dark:bg-gray-800">
                            <tr>
                                <th className="border px-2 py-1">Nom du Type Link</th>
                                <th className="border px-2 py-1">Supprimer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {linkTypes.map((lt, index) => {
                                const bgColor = index % 2 === 0 ? "dark:bg-gray-600 bg-gray-050" : "dark:bg-gray-700 bg-gray-100";
                                return (
                                    <tr key={lt.id} className={`${bgColor}`}>
                                        <td className="border px-2 py-1">{lt.type_link_name}</td>
                                        <td className="border px-2 py-1">
                                            <button
                                                onClick={() => handleDelete(lt.id)}
                                                className="text-red-500 underline text-2xl"
                                            >
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
